import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/service/login.service';
import {
  emailOrPhoneValidator
} from 'src/validator';
import { NgxOtpInputComponent } from 'ngx-otp-input';
import { CustomSnackbarService } from 'src/app/components/custom-notification/custom-notification.component';
import { RegisterService } from 'src/app/service/register.service';
import { PageStateService } from 'src/app/service/page-state.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword: boolean = false;
  loginForm: any = FormGroup;
  password: string = '';

  showOTPInput: boolean = false;
  isFormSubmit: boolean = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private register : RegisterService,
    private customSnackbarService: CustomSnackbarService,
    private pageStateService: PageStateService
  ) {
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      un: new FormControl('', [Validators.required, emailOrPhoneValidator()]),
      pwd: new FormControl('', [Validators.required]),
    });
    if(localStorage.getItem("marieTokenAdmin")) {
      if(localStorage.getItem("name") == "Admin") {
        this.router.navigateByUrl(`/product-listing`);
      }
      else{
        this.router.navigateByUrl(`/validation-listing`);
      }
      // this.router.navigateByUrl(`/product-listing`);
    }
  }

  login() {
    this.isFormSubmit = true;
    if (this.loginForm.valid) {
      this.loginService.loginUser(this.loginForm.value).then((res) => {
        if (res.status == 'SUCCESS') {
          localStorage.setItem('name', res.data.name)
          localStorage.setItem('marieTokenAdmin', res.data.token);
          localStorage.setItem('menuList', JSON.stringify(res.data.menu));
          localStorage.setItem('uiPrivileges', JSON.stringify(res.data.uiPrivileges));

          this.pageStateService.resetCurrentPage();

          if(res.data.menu[0]?.menuItems[0]?.url) {
            this.router.navigateByUrl(res.data.menu[0].menuItems[0].url);
          } else {
            this.router.navigateByUrl(res.data.menu[0].url);
          }
          // this.redirectFromMenu(res.data.menu, res.data.seller);
          // this.getUserInfo();
        } else if (res.status == 'FAILED') {
          this.customSnackbarService.openCustomSnackbar(res.desc, 3000, true)
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  get emailValid() {
    return this.loginForm.get('un');
  }

  get passwordValid() {
    return this.loginForm.get('pwd');
  }

  redirectFromMenu(data:any, loginType: any) {
    let _menu = data;
    let _loginType = loginType;

    // Array to store all menu items
    let _allMenuItems: any = [];

    if(_loginType) {
      _allMenuItems = _menu.filter((item:any)  => item.menuItems);
      localStorage.setItem('menuList', JSON.stringify(_allMenuItems));
      console.log(_allMenuItems, "_allMenuItems1")
      this.router.navigateByUrl(_allMenuItems[0].menuItems[0].url);

    } else {
      _allMenuItems = _menu.filter((item:any) => !item.menuItems);
      localStorage.setItem('menuList', JSON.stringify(_allMenuItems));
      console.log(_allMenuItems, "_allMenuItems2")
      this.router.navigateByUrl(_allMenuItems[0].url);
    }


  }

  getUserInfo() {
    this.register
      .fetchUserDetails()
      .then((res) => {
        if (res.status === "SUCCESS") {
          let user = res.data.user;
          if(user.roleName == "AMDIN"){
            this.router.navigateByUrl(`/product-listing`);
          }else{
            this.pageStateService.resetCurrentPage();
            this.router.navigateByUrl(`/validation-listing`);
          }
        }
      });
  }

}
